import React from 'react';
import PropTypes from 'prop-types';
import VCard from 'vcard-creator';

const getVCFUrl = (VCardData) => {
  try {
    const myVCard = new VCard();

    const number = Number('11223344');
    myVCard
      // add personal data
      .addName(
        VCardData.lastname,
        VCardData.firstname,
        VCardData.additional,
        VCardData.prefix,
        VCardData.suffix
      )
      // add work data
      .addCompany(VCardData.website)
      .addJobtitle(VCardData.jobTitle)
      .addRole(VCardData.jobTitle)
      .addEmail(VCardData.email)
      .addPhoneNumber(number, 'PREF;WORK')
      .addURL(VCardData.website);

    console.log(myVCard.toString().replaceAll('11223344', VCardData.workNum));
    const textData = myVCard
      .toString()
      .replaceAll('11223344', VCardData.workNum);
    const blobObj = new Blob([textData], { type: 'text/x-vcard' });
    return window.URL.createObjectURL(blobObj);
  } catch (e) {
    console.log('failed to create link');
  }
  return '#';
};

function VCFLink(props) {
  // const VCardData = {
  //   firstname: 'Ali',
  //   lastname: 'Ogaili',
  //   prefix: '',
  //   suffix: '',
  //   additional: '',
  //   jobTitle: 'Software Engineer',
  //   email: 'ali@meronex.com',
  //   workNum: '00971502507855', //all digits
  //   website: 'http://www.meronex.com',
  // };

  const { linkText, VCardData } = props;

  const url = getVCFUrl(VCardData);
  return (
    <a
      style={{ color: 'inherit', textDecoration: 'inherit' }}
      href={url}
      id={'downloadLink'}
      download={'card.vcf'}>
      {linkText}
    </a>
  );
}
VCFLink.propTypes = {
  VCardData: PropTypes.object,
  linkText: PropTypes.string,
};

VCFLink.defaultProps = {};
export default VCFLink;
